import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { primeQueryCache } from "../../../utils/primeQueryCache";
import { CoachDto } from "../../../models/coach/dto/coach.dto";
import { GET_COACH_QUERY_KEY } from "./useGetCoach";

export const GET_COACHS_QUERY_KEY = (organizationId: string) => [organizationId, 'coachs'];
export const useListCoachs = (organizationId: string) => {
    const client = useApiClient();
    const queryClient = useQueryClient();

    return useQuery({
        enabled: Boolean(organizationId),
        queryKey: GET_COACHS_QUERY_KEY(organizationId),
        queryFn: () => client.fetchApi<CoachDto[], {}>({ endpoint: `coachs?organizationId=${organizationId}`, method: 'GET' }),
        onSuccess: (data: CoachDto[]) => {
            // O(items), not O(items × cache) — see primeQueryCache for the org-switch freeze this loop was part of.
            primeQueryCache(queryClient, (item) => GET_COACH_QUERY_KEY(item.id), data);
        },
    });
};